import React, { FC, HTMLProps } from 'react';
import cn from 'classnames';
import styles from './StudioArrow.module.scss';

interface OwnProps extends HTMLProps<HTMLButtonElement> {
  direction: 'left' | 'right';
}

const StudioArrow: FC<OwnProps> = ({ className, direction, onClick }) => {
  const rotate = direction === 'right' ? 0 : 180;

  return (
    <button className={cn(className, styles.arrow)} onClick={onClick}>
      <svg
        width="44"
        height="44"
        viewBox="0 0 44 44"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        style={{ transform: `rotate(${rotate}deg)`, opacity: 0.7 }}
      >
        <g filter="url(#filter0_b_5545_13840)">
          <rect width="44" height="44" rx="22" fill="white" fillOpacity="0.7" />
          <path d="M19 15L26 22L19 29" stroke="black" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
        </g>
        <defs>
          <filter
            id="filter0_b_5545_13840"
            x="-24"
            y="-24"
            width="92"
            height="92"
            filterUnits="userSpaceOnUse"
            colorInterpolationFilters="sRGB"
          >
            <feFlood floodOpacity="0" result="BackgroundImageFix" />
            <feComposite in2="SourceAlpha" operator="in" result="effect1_backgroundBlur_5545_13840" />
            <feBlend mode="normal" in="SourceGraphic" in2="effect1_backgroundBlur_5545_13840" result="shape" />
          </filter>
        </defs>
      </svg>
    </button>
  );
};

export default StudioArrow;
